import styled from 'styled-components';

const SearchConditionStyled = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 32px;
  position: relative;
  .update-time-wrap {
    position: absolute;
    top: -52px;
    right: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    .time-content {
      height: 32px;
      font-size: 14px;
      font-family: 'SourceHanSansCNRegular', sans-serif;
      font-weight: 400;
      color: #424242;
      line-height: 32px;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 12px;
      border: 1px solid #ffffff;
      padding: 0 24px;
    }
  }
  .card-content-wrap {
    /* padding: 40px 40px; */
    display: flex;
    flex-direction: row;
    gap: 36px;
    .single-select,
    .date-wrap,
    .sub-channel-select {
      width: 100%;
      color: #ffffff;
      .Mui-selected {
        /* color: #ffffff !important; */
        background: #3c8ec0 !important;
      }
    }
    .ant-select {
      border-bottom: 1px solid #999;
    }
  }
  .MuiTypography-root {
    color: #1d8fc0 !important;
  }
  .MuiTypography-root.Mui-selected {
    color: #1d8fc0 !important;
  }
  .MuiInput-root,
  .MuiIconButton-root,
  .MuiPaper-root,
  .MuiPaper-root,
  .MuiMenu-paper-MuiPaper-root,
  .MuiPopover-paper {
    color: #1d8fc0 !important;
  }
  .MuiPaper-root {
    color: #1d8fc0 !important;
  }
  .Mui-selected {
    background: #1d8fc0 !important;
  }
  .MuiTypography-root.Mui-selected,
  .MuiTypography-root,
  .MuiPaper-root {
    color: #1d8fc0 !important;
  }
  .MuiSelect-icon,
  .MuiSvgIcon-root {
    color: #1d8fc0 !important;
  }
  .MuiInputLabel-root.Mui-focused {
    color: #1d8fc0 !important;
  }
`;

export default SearchConditionStyled;
